import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowDownWall: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-down-wall"><path d="M19.25 3.75L4.75 3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M16.5 15.75L12 20.25L7.5 15.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12 7.75V19.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconArrowDownWall;
